import { render } from "./PromocodeList.vue?vue&type=template&id=45a77191"
import script from "./PromocodeList.vue?vue&type=script&lang=js"
export * from "./PromocodeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__